function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2b4673",
  stopOpacity: 0.902
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#16233a",
  stopOpacity: 0.902
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M2176.281,1649.029c-132.318-27.377-151-2.589-271.614-50.555-135.654-53.946-421.988-14.881-622.342-57.666s-198.375-113.474-349.458-206.484-360.33-81.85-507.686-132.075c-87.532-29.835-140.4-65.577-168.9-89.681v589.9l1920-1.372Z",
  transform: "translate(-256.281 -1112.567)"
});

function SvgBlobBg(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 589.895,
    viewBox: "0 0 1920 589.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobBg);
export default __webpack_public_path__ + "static/media/blob-bg.9af2533b76a861ba7b59c6bc07ba8710.svg";
export { ForwardRef as ReactComponent };